import { cn } from 'cn'

import { initialsOf } from '../normalize'
import type { Account } from '../types'

/** An account's logo, or its initials on a tinted tile when it has none. */
export function AccountLogo({ account, className }: { account: Pick<Account, 'accountName' | 'logoUrl'>; className?: string }) {
  return (
    <span
      className={cn(
        'flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-line bg-purple-soft text-xs font-semibold text-deep-purple',
        className,
      )}
    >
      {account.logoUrl ? (
        <img src={account.logoUrl} alt={`${account.accountName} logo`} className="size-full object-contain p-0.5" />
      ) : (
        <span aria-hidden>{initialsOf(account.accountName)}</span>
      )}
    </span>
  )
}
